module.exports = function (data) {
    const event = {
        event: 'BWSAUproductClick',
        eventContext: {
            productRank: data.productRank,
            productSKU: data.productSKU,
            isSponsored: data.isSponsored ? 'yes' : 'no',
            promoteIQCampaignId: data.promoteIQCampaignId ? data.promoteIQCampaignId : null,
            linkName: data.isSponsored ? 'web:browse:product click:sponsored' : 'web:browse:product click',
            linkType: 'product click from listing pages'
        }
    };

    if (data.searchTerm) {
        event.eventContext.searchKeyword = data.searchTerm;
        event.eventContext.linkName = data.isSponsored ? 'web:search:product click:sponsored' : 'web:search:product click';
    }
    return event;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/atm/product-click-mapper.js
 **/